import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const legalItems = [
  {
    label: '販売事業者',
    value: '株式会社ヴェリテ',
  },
  {
    label: '販売責任者',
    value: '苫米地 真美',
  },
  {
    label: '所在地',
    value: '〒980-0802 宮城県仙台市青葉区二日町14-14 二日町ゲートビル2階',
  },
  {
    label: '電話番号',
    value: '022-211-5488（受付時間：平日 9:00〜18:00）',
  },
  {
    label: 'メールアドレス',
    value: 'verite@frise.support',
  },
  {
    label: '販売価格',
    value: '各サービスの料金は「料金の目安」ページ（/pricing）に税込表示。最終金額はヒアリング・お見積り後に個別提示。',
  },
  {
    label: '代金の支払方法',
    value: '銀行振込、クレジットカード（決済代行サービス経由）',
  },
  {
    label: '代金の支払時期',
    value: '個別契約に基づき定める（例：着手金・納品時・月額請求など）',
  },
  {
    label: 'サービスの提供時期',
    value: '契約・ヒアリング後、内容により約4〜8週間（制作系）。月額保守は契約開始月の翌月から。',
  },
  {
    label: '商品代金以外の必要料金',
    value: '銀行振込手数料はお客様負担。制作に伴う交通費・実費（印刷代・素材購入等）は別途見積り。月額保守プラン（6,000円〜）にはドメイン・サーバー維持および軽微な修正を含む（大幅改修は別途見積り）。',
  },
  {
    label: '返品・キャンセル・不良品',
    value: '制作・役務提供のキャンセルは、お申込み・契約後かつ制作着手前であればご相談に応じます。制作着手後のキャンセル・返金には原則応じかねます。納品物に契約内容と著しく異なる瑕疵がある場合は、納品後7日以内にメールまたは電話でご連絡ください。状況を確認のうえ対応いたします。',
  },
  {
    label: '中途解約について',
    value: `当社が提供する月額制の保守・管理サービス（以下「月額サービス」）は、以下のとおり解約いただけます。

■解約のお申し出方法
メール（verite@frise.support）または電話（022-211-5488、受付時間：平日9:00〜18:00）にて、ご契約者名・ご契約内容・解約希望日を明記のうえお申し出ください。

■解約の申込期限
次回の請求日（契約更新日）の10日前までにお申し出いただいた場合、当該請求日をもって解約の効力が生じます。期限を過ぎてお申し出いただいた場合は、原則として翌回の請求日をもって解約の効力が生じます。

■解約後の請求
解約の効力が生じた日の属する月の翌月以降、月額料金の請求は行いません。

■返金について
既にお支払いいただいた料金について、日割り計算による返金は行いません。

■最低利用期間
個別契約書に別段の定めがある場合はその定めに従います。定めがない場合は、最低利用期間は設けておりません。`,
  },
];

export default function Legal() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />

      <section className="pt-24 md:pt-32 pb-16 md:pb-20">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-6">
                特定商取引法に基づく表記
              </h1>
            </div>

            <div className="bg-background-50 rounded-2xl border border-background-200 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <tbody>
                    {legalItems.map((item, idx) => (
                      <tr
                        key={idx}
                        className={`border-b border-background-200/60 align-top ${
                          idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                        }`}
                      >
                        <td className="px-6 py-4 font-semibold text-foreground-700 w-44 whitespace-nowrap">
                          {item.label}
                        </td>
                        <td className="px-6 py-4 text-foreground-900 leading-relaxed">
                          {item.label === '中途解約について' ? (
                            <div className="whitespace-pre-line">{item.value}</div>
                          ) : (
                            item.value
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}